<template>
	<div>
        <div style="width: 310px;height: 143px;margin: auto;">
            <p style="text-align: center;line-height: 47px;font-size: 18px">{{userInfo.name}}</p>
            <van-divider />
            <div style="line-height: 66px;">
                <div class="position">
                    <van-button color="#43D7B5" icon="add-o" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -33px;margin-left: 40px;">会员证</p>
                </div>
                <div class="position">
                    <van-button color="#6DD400" icon="edit" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -33px;margin-left: 39px;">联系信息</p>
                </div>
                <div class="position">
                    <van-button color="#F7B500" icon="cash-back-record" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -33px;margin-left: 38px;">研究信息</p>
                </div>
            </div>
        </div>

        <div class="cellposition">
            <van-cell icon="shop-o" title="我的积分" is-link />
            <van-cell icon="shop-o" title="会员缴费" is-link />
        </div>

        <div  class="cellposition">
            <van-cell icon="shop-o" title="我的好友" is-link />
            <van-cell icon="shop-o" title="关注机构" is-link />
            <van-cell icon="shop-o" title="我的收藏" is-link />
            <van-cell icon="shop-o" title="我的举报" is-link />
        </div>

        <div  class="cellposition">
            <van-cell icon="shop-o" title="提案投票" is-link />
            <van-cell icon="shop-o" title="选举投票" is-link />
        </div>

        <div  class="cellposition">
            <van-cell icon="shop-o" title="意见反馈" is-link />
            <van-cell icon="shop-o" title="设置" is-link />
        </div>
        <tabbar></tabbar>
    </div>
</template>

<script>
import {
    Cell,
    CellGroup,
    Divider ,
    Button ,
} from 'vant';
import {} from "@/api/dictionary";
import {} from "@/utils/sessionStorage.js"
import tabbar from "../../components/tabbar"
import {mapState} from "vuex";
export default {
  data() {
    return {
    };
  },
  filters: {
    
  },
  components: {
      tabbar,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      [Divider .name]:Divider ,
      [Button .name]:Button ,
  },
  methods: {
	 
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch:{
	
  },
  mounted() {
	  
  }

}
</script>
<style>
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }
    .van-button {margin-left: 40px;}
    .position{float: left;margin-left: 11px;}
    .cellposition{width: 310px;margin: auto;}
    /*.position i{margin-left: 10px;}*/
</style>